module.exports = __webpack_public_path__ + "img/Meine-Flotte---Ueberlandverkehr.fc760299.svg";